import { DashboardLayout } from '../../../app/components';
import { routingPath } from '../../../app/routes';
import { SimulationMain } from '../pages';

const SimulationRoutes = () => {
  return {
    element: <DashboardLayout />,
    children: [
      {
        path: routingPath.simulation.main,
        element: <SimulationMain />,
      },
    ],
  };
};

export default SimulationRoutes;
